/**
 * @file mutations
 */

export default {
    isSideBarShow: true,
    loading: false,
    userInfo: {
        token: '',
        userName: ''
    }
};
